import eventBus from '@/uteis/eventBus'

export default {
  'MUT_COMPONENT_VISIBLE_PROPS' (state, payload) {
    state.isVisible = {
      ...payload
    }
  },

  'MUT_CHANGE_FILTRO_INTERESSADO' (state, payload) {
    state.filtroInteressados = payload
  },

  'MUT_CHANGE_CONTATO_SELECIONADO' (state, payload) {
    state.contatoSelecionado = payload
  },

  'MUT_ADD_CONTATO_INTERESSADO' (state, payload) {
    state.interessadosSelecionados = payload
  },

  'MUT_CONTATO_INTERESSADO' (state, payload) {
    state.interessadosSelecionados = payload
  },

  'MUT_MOTIVO_SELECIONADO' (state, payload) {
    state.motivoSelecionado = payload
  },

  'MUT_MOTIVOS_PROCESSO' (state, payload) {
    state.motivosProcessos[payload.itemData.processo] = payload
  },

  'MUT_DEFAULT_MOTIVOS_PROCESSO' (state) {
    state.motivosProcessos = {}
  },

  'MUT_LIMPAR_FILTRO_PESQUISA' (state) {
    state.filtroInteressados = {
      ...state.filtroInteressados,
      filtro: null,
      cpf: null,
      cnpj: null,
      matricula: null
    }
    state.contatoSelecionado = []
  },

  'MUT_FILTRO_PESQUISA_A_RECEBER' (state, payload) {
    state.filtroPesquisaAReceber = {
      ...state.filtroPesquisaAReceber,
      ...payload
    }
  },

  'MUT_FILTRO_PESQUISA_GERAL' (state, payload) {
    state.filtroGeral = {
      ...state.filtroGeral,
      ...payload
    }
  },

  'MUT_AUX_FILTRO_PESQUISA_GERAL' (state, payload) {
    state.auxFiltroGeral = {
      ...state.auxFiltroGeral,
      ...payload
    }
  },

  'MUT_LIMPAR_FILTRO_PESQUISA_GERAL' (state) {
    state.filtroGeral = {}
    state.progressFiltroGeral = {
      change: !state.progressFiltroGeral.change
    }
  },

  'MUT_LIMPAR_PROTOCOLO_APENSADO_SELECIONADO' (state) {
    state.apensarProcessoSelecionado.processo = {}
  },

  'MUT_LIMPAR_PROTOCOLO_ANEXADO_SELECIONADO' (state) {
    state.anexarProcessoSelecionado.processo = {}
  },

  'MUT_PROCESSO_CADASTRO' (state, payload) {
    state.processoCadastro = payload
  },

  'MUT_PROCESSO_GUIA' (state, payload) {
    state.processosGuia = payload
  },

  'MUT_DADOS_SESSAO' (state, payload) {
    state.dadosSessao = payload
  },

  'MUT_ASSUNTO' (state, payload) {
    state.processoCadastro.assunto = payload
  },

  'MUT_ESPECIE' (state, payload) {
    state.processoCadastro.especie = payload || {}
    state.processoCadastro.idEspecie = payload.codigoEspecie || ''
    state.processoCadastro.especieDescricao = payload.especie || ''
    state.processoCadastro.assunto = payload.assunto || {}
    state.processoCadastro.codigoAssunto = payload.assunto ? payload.assunto.codigoAssunto : ''
  },

  'MUT_DOCMENTO' (state, payload) {
    state.documentoCadastro = payload
  },

  'MUT_PAIS' (state, payload) {
    state.documentoCadastro.pais = payload.descricao || ''
    state.documentoCadastro.paisChave = payload.chave || ''
    state.documentoCadastro.estado = ''
    state.documentoCadastro.estadoChave = ''
    state.documentoCadastro.cidade = ''
    state.documentoCadastro.cidadeChave = ''
  },

  'MUT_ESTADO' (state, payload) {
    state.documentoCadastro.estado = payload.descricao || ''
    state.documentoCadastro.estadoChave = payload.chave || ''
    state.documentoCadastro.cidade = ''
    state.documentoCadastro.cidadeChave = ''
  },

  'MUT_CIDADE' (state, payload) {
    state.documentoCadastro.cidade = payload.descricao || ''
    state.documentoCadastro.cidadeChave = payload.chave || ''
  },

  'MUT_FILTRO_DESTINATARIO_DEPARTAMENTO' (state, payload) {
    state.filtroDestinatario = { ...state.filtroDestinatario, ...payload }
    eventBus.$emit('filtroDepartamentoDestinatario', payload)
  },

  'MUT_APENSAR_PROCESSO_SELECIONADO' (state, payload) {
    state.apensarProcessoSelecionado = payload
  },

  'MUT_ANEXAR_PROCESSO_SELECIONADO' (state, payload) {
    state.anexarProcessoSelecionado = payload
  },

  'MUT_DATA_TABLE_CHECKED' (state, payload) {
    state.dataTableChecked = payload
  },

  'MUT_KEY_TABLE_CHECKED' (state, payload) {
    state.keyTableChecked = payload
  },

  'MUT_LOADING' (state, payload) {
    state.loading.count += payload
    if (state.loading.count === 0) {
      state.loading.is = false
    } else {
      state.loading.is = true
    }
  },

  'MUT_PROCESSOS_TRAMITACAO' (state, payload) {
    state.processosTramitacao = payload
  },

  'MUT_DOCUMENTO' (state, payload) {
    state.documento = payload
  },

  'MUT_NOTIFICATION' (state, payload) {
    state.notification = {
      ...state.notification,
      ...payload,
      key: !state.notification.key
    }
  }
}
